import { odata } from '../../conf';
import Actions from '../../odata/actions';

const actions = new Actions('stockItemFile', 'stockItemFiles');

const customActions = {
  async LOAD_stockItemFiles({ rootGetters, commit }, stockItemId) {
    const data = await odata.o(rootGetters)
      .get('stockItemFiles')
      .query({
        $filter: `IsDeleted eq false AND stockItemId eq ${stockItemId}`,
        $orderby: 'created desc',
      });
    commit('SET_stockItemFiles', data);
    return data;
  },
};

export default { ...actions, ...customActions };
